import "../../styles/settings/manageSubscription.css";
import { BsArrowBarLeft, BsCalendarDate, BsCheck } from "react-icons/bs";
import { subscriptionURL, cancelSubscriptionURL, freeSubscriptionUrl, startStarterPlanUrl } from "../../api/endpoints";
import { useState, useMemo, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { setUser } from "../../slice/webStoreUserSlice";
import { useNavigate } from "react-router-dom";
import coinImage from "../../assetsStatic/coin.png";
import { FaAngleRight } from "react-icons/fa";
import PaystackPop from "@paystack/inline-js";
import { io } from "socket.io-client";
import Spinner from "../../components/uxCollections/Loaders";
import DeliverToggle, { SubscriptionToggle } from "../../components/toggleButton/DeliverToggle";
import TrialShowcase from "./FreeTrail";
import { Check, X, Sparkles } from "lucide-react";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert";

/* const subscriptionPlanCodes=[
  {
    plan: "Basic",
    planCodeMonthly: "PLN_lbro2p90abucr1i",
    planCodeHalfYearly: "PLN_7j4uikc9xu8noq2",
  },
  {
    plan:"Super",
    planCodeMonthly: "PLN_gz3p2q94b9r0apg",
    planCodeHalfYearly: "PLN_f1eh57906yzkibz",
  },
  {
    plan:"Premium",
    planCodeMonthly: "PLN_o0yjesxw73ffcvr",
    planCodeHalfYearly: "PLN_e4eaehblco2v3dv",
  }
] */
const subscriptionPlanCodes = {
  monthly: [
    {
      plan: "Basic",
      //planCode: "PLN_lbro2p90abucr1i", //test
      planCode: "PLN_g50cl5n3nuonb7e", // production updated
    },
    {
      plan: "Super",
      planCode: "PLN_ga57y90xb1rmd5c", // production updated
    },
    {
      plan: "Premium",
      planCode: "PLN_mm0gxdw1y6px2vy", // production updated
    },
  ],

  halfYearly: [
    {
      plan: "Basic",
      planCode: "PLN_ll2nkwfuw2buqvn", // production updated
    },
    {
      plan: "Super",
      planCode: "PLN_7o2fzpjnvtry6nw", // production updated
    },
    {
      plan: "Premium",
      planCode: "PLN_codo301s6392grs", // production updated
    },
  ],
};

/* { name, price, discountPrice, currency, includes, popular, setIsLoading, socket, planCode, subscriptionRange } */
const SubCard = ({ plan, index, setIsLoading, socket, currency }) => {
  console.log(plan);

  const { user } = useSelector((state) => state.webStoreUser);

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const popup = new PaystackPop();

  const handlePlanSelect = async (selected) => {};

  /* {
      name: "Basic",
      badge: "Saver",
      price: 4000,
      originalPrice: 8000,
      period: subscriptionRange,
      color: "slate",
      popular: false,
      planCode:`${subscriptionRange === "monthly" ? subscriptionPlanCodes.monthly[0].planCode : subscriptionPlanCodes.halfYearly[0].planCode}`,
      features: [
        "Create one store",
        "Business KPI tracking",
        "List only 200 products",
        "Free support",
        "Access our E-Commerce Hub",
        "Free Personel training",
        "2% discount on extra services",
      ],
    }, */
  const handleSubSelection = async (selected) => {
    uiAlert("You are about to subscribe to " + plan.name + " plan for " + plan.price.toLocaleString() + " " + plan.period + ". Click ok to continue");
    let accessToken = localStorage.getItem("accessToken");
    console.log(selected);
    const payload = { userType: plan.name, price: plan.price, subscriptionRange: plan.period, plan_code: plan.planCode };

    try {
      let response = await fetch(subscriptionURL, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(payload),
      });
      if (response.status === 400) {
        // send refresh token
        console.log("expired token send refresh token");
        navigate("/sign-in");
      }
      if (response.ok) {
        socket.emit("paymentCreated", user?._id);
        let { accessCode } = await response.json();
        popup.resumeTransaction(accessCode, {
          onCancel: function () {
            setIsLoading(false);
          },
        });
        setIsLoading(true);
        // dispatch(setUser(data));
        // console.log("subscription updated", data);
      }
    } catch (error) {
      console.log(error);
    } finally {
      //  setIsLoading(false);
    }
  };

  {
    /* <div onClick={() => handleSubSelection({ userType: name, price, subscriptionRange, plan_code: planCode })}>
      <div className='subscriptionCard'>
        <p>Saver</p>
        <div style={{ backgroundColor: ` ${name === "Basic" ? "black" : name === "Super" ? "#0e49b5" : "rgb(82, 9, 124)"} ` }}> {name}</div>
        <div>
          <span className='currencySubCard'> {currency} </span>
          <span className='realPrice863'>
            {currency} {price.toLocaleString()}{" "}
          </span>
          <p>{discountPrice.toLocaleString()}</p>
        </div>
        <p style={{ fontWeight: "bold" }}>{subscriptionRange === "monthly" ? "Monthly" : "6 months"}</p>
        <p>For {name?.toLowerCase()} users and it includes:</p>
        <div className='packageIncludes'>
          {includes?.map((item, index) => (
            <div key={index}>
              <BsCheck color='green' />
              <p>{item}</p>
            </div>
          ))}
          
        </div>
        <button className='chooseplanButton'>Choose plan</button>
        {popular && <p className='recommenedPack'>popular</p>}
      </div>
    </div> */
  }
  return (
    <div key={index} className={`prcard__card__wrapper__base__3m7p4q ${plan?.popular ? "prcard__card__popular__variant__9j6k2w" : ""}`}>
      {/* Popular Badge */}
      {plan?.popular && <div className='prcard__popular__badge__label__4n8m5r'>popular</div>}

      {/* Card Header */}
      <div className='prcard__card__inner__content__7q3k9m'>
        {/* Badge */}
        <div className='prcard__saver__badge__tag__2w5h8p'>{plan?.badge}</div>

        {/* Plan Name */}
        <div className={`prcard__plan__name__badge__6k4m7n prcard__plan__color__${plan?.color}__9p2j5t`}>
          <span>{plan?.name}</span>
        </div>

        {/* Pricing */}
        <div className='prcard__pricing__section__block__8n6k3w'>
          <div className='prcard__original__price__strike__5m9h2p'>
            <span>
              {currency}
              {plan?.originalPrice.toLocaleString()}
            </span>
          </div>
          <div className='prcard__current__price__display__7k4n8q'>
            <span>
              {currency}
              {plan?.price.toLocaleString()}
            </span>
          </div>
          <p className='prcard__period__label__text__3p6m9k'>{plan?.period}</p>
        </div>

        {/* Description */}
        <p className='prcard__description__text__para__4k7n2m'>
          {plan?.name === "Basic" && "For basic users and it includes:"}
          {plan?.name === "Super" && "For super users and it includes:"}
          {plan?.name === "Premium" && "For premium users and it includes:"}
        </p>

        {/* Features */}
        <ul className='prcard__features__list__container__9m5k6p'>
          {plan?.features.map((feature, idx) => (
            <li key={idx} className='prcard__feature__item__row__2k8n4q'>
              <Check className='prcard__check__icon__svg__7h3m9p' />
              <span>{feature}</span>
            </li>
          ))}
        </ul>

        {/* CTA Button */}
        <button onClick={() => handleSubSelection(plan)} className={`prcard__cta__button__main__5n9k6m prcard__cta__color__${plan?.color}__8p4j7w`}>
          Choose plan
        </button>
      </div>
    </div>
  );
};

const WHATSAPP_NUMBER = "2348159273522";
export const WHATSAPP_BASE = `https://wa.me/${WHATSAPP_NUMBER}`;

const ManageSubscription = () => {
  const socket = useMemo(() => io(process.env.REACT_APP_Back_end_api_root, { transports: ["websocket"] }), []);
  const [openOnlineVendorModal, setOpenOnlineVendorModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [subscriptionRange, setSubscriptionRange] = useState("monthly");
  const { user } = useSelector((state) => state.webStoreUser);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    console.error(isLoading);
  }, [isLoading]);

  useEffect(() => {
    // connect to socket and create room with user._id
    socket.on("connect", () => {
      console.log(socket.id); // x8WIv7-mJelg7on_ALbx
      socket.emit("createRoom", user?._id);
    });

    socket.on("userSubscribed", (incomingUser) => {
      if (incomingUser?._id.toString() === user?._id.toString()) {
        uiAlert("Congratulations!!!. You are now subscribed", "success");
        dispatch(setUser(incomingUser));
        setIsLoading(false);
      }
      console.error("user subscribed", user);
    });
    socket.on("userUnsubscribed", (user) => {
      if (user?._id.toString() === user?._id.toString()) {
        dispatch(setUser(user));
        /*  setIsLoading(false); */
        uiAlert("subscription cancelled", "success");
      }
    });

    return () => {
      socket.disconnect();
    };
  }, []);

  const plans = [
    {
      name: "Basic",
      badge: "Saver",
      price: subscriptionRange === "monthly" ? 3500 : 19000,
      originalPrice: 8000,
      period: subscriptionRange,
      color: "slate",
      popular: false,
      planCode: `${subscriptionRange === "monthly" ? subscriptionPlanCodes.monthly[0].planCode : subscriptionPlanCodes.halfYearly[0].planCode}`,
      features: [
        "Create one store",
        "Business KPI tracking",
        "List only 250 products",
        "Free support",
        "Access our E-Commerce Hub",
        "Free Personel training",
        "24 hours free Ad monthly",
        "2% discount on extra services",
      ],
    },
    {
      name: "Super",
      badge: "Saver",
      popular: true,
      price: subscriptionRange === "monthly" ? 9500 : 55000,
      originalPrice: 17000,
      period: subscriptionRange,
      color: "blue",
      planCode: `${subscriptionRange === "monthly" ? subscriptionPlanCodes.monthly[1].planCode : subscriptionPlanCodes.halfYearly[1].planCode}`,
      features: [
        "Basic user Ad ons",
        "Create two stores",
        "Create one warehouse",
        "60 hours free Ad monthly",
        "List upto 1500 products",
        "Free hardware installation and leasing options",
        "10% discount on extra services",
        "Free personel training",
      ],
    },
    {
      name: "Premium",
      badge: "Saver",
      price: subscriptionRange === "monthly" ? 22500 : 125000,
      originalPrice: 42500,
      period: subscriptionRange,
      popular: false,
      color: "purple",
      planCode: `${subscriptionRange === "monthly" ? subscriptionPlanCodes.monthly[2].planCode : subscriptionPlanCodes.halfYearly[2].planCode}`,
      features: [
        "Super user Ad ons",
        "Create upto 5 stores",
        "Create 3 warehouses",
        "150 hours free Ad monthly",
        "List up 11200 products",
        "Free hardware installation and leasing options",
        "30% discount on extra services",
        "Free personel training",
      ],
    },
  ];

  const handleCancelSubscription = async () => {
    let accessToken = localStorage.getItem("accessToken");

    if (!window.confirm("Are you sure you want to cancel your subscription?")) {
      return;
    }

    try {
      let response = await fetch(cancelSubscriptionURL, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.status === 400) {
        /* send refresh token */
        console.log("expired token send refresh token");
        navigate("/sign-in");
      }
      if (!response.ok) {
        uiAlert("An error occurred while cancelling your subscription. Please try again, or contact support", "error");
        return;
      }
      if (response.ok) {
        uiAlert("You have successfully cancelled your subscription", "success");
        let data = await response.json();
        dispatch(setUser(data));
        console.log("subscription updated", data);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const startFreeTrial = async () => {
    /*     return uiAlert("The starter plan is currently unavailable. Please contact support for more information.", "info"); */

    let accessToken = localStorage.getItem("accessToken");
    setIsLoading(true);
    try {
      let response = await fetch(freeSubscriptionUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ userType: "Free", price: "0", subscriptionRange: "monthly", plan_code: "free" }),
      });
      if (response.status === 400) {
        /* send refresh token */
        console.log("expired token send refresh token");
        navigate("/sign-in");
      }
      if (response.ok) {
        let user = await response.json();
        dispatch(setUser(user));
        uiAlert("You have started a free trial for 7 days", "success");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      {!user.userIsSubscribed ? (
        <div className='mSubscriptionWrapper'>
          <h3 className='privacy-data-info-title cp-title' style={{ fontWeight: "900" }}>
            Choose your plan
          </h3>
          <p>You need to choose a subscription plan to create stores, warehouse and Manage your inventory. You can always cancel at anytime</p>
          <div className='subSwitch283'>
            <span
              style={
                subscriptionRange === "monthly"
                  ? {
                      color: "rgb(86, 137, 55)",
                      fontWeight: "bold",
                      fontSize: "1rem",
                    }
                  : {}
              }
            >
              Monthly
            </span>
            <SubscriptionToggle toggleValue={subscriptionRange} updatetoggle={setSubscriptionRange} />
            <span
              style={
                subscriptionRange === "halfYearly"
                  ? {
                      color: "rgb(106 157 207)",
                      fontWeight: "bold",
                      fontSize: "1rem",
                    }
                  : {}
              }
            >
              Half yearly
            </span>
          </div>
          <div onClick={() => setOpenOnlineVendorModal(true)}>
            <div className='prcard__banner__container__7h2m5p'>
              <div className='prcard__free__banner__clickable__9d3k8v'>
                <div className='prcard__banner__hover__overlay__5t6p2w'></div>
                <div className='prcard__banner__flex__content__8n4j7q'>
                  <div className='prcard__banner__text__group__3r9m1k'>
                    <div className='prcard__title__icon__row__6w8h4s'>
                      <Sparkles className='prcard__sparkle__icon__svg__2p5n7t' />
                      <h2 className='prcard__banner__main__title__4k9d6v'>Free Plan</h2>
                    </div>
                    <p className='prcard__banner__subtitle__text__7m3q8r'>Start your journey with no commitment • Perfect for testing</p>
                  </div>
                  <button className='prcard__banner__cta__button__5h2k9p'>Get Started Free →</button>
                </div>
              </div>
            </div>
          </div>
          <div className='prcard__grid__container__main__8k5j2n'>
            {plans.map((plan, index) => {
              return <SubCard plan={plan} index={index} setIsLoading={setIsLoading} socket={socket} currency={user.userCountryCurrencySymbol} />;
            })}
          </div>
          {user.freePlanUsed ? (
            <p>
              Do you need an <span style={{ color: "rgb(165, 126, 17)", fontWeight: "bolder" }}>Enterprice package</span>?{" "}
              {/* you can start a <span style={{ color: "#b6a843", cursor: "pointer", fontWeight: "bold" }}>free 2 days Trial </span> */}{" "}
              <span
                onClick={() => {
                  window.open(`${WHATSAPP_BASE}?text=Hello, I would like to inquire about your enterprise package.`, "_blank");
                }}
                style={{ color: "rgb(9, 76, 126)", cursor: "pointer", fontWeight: "bold" }}
              >
                Contact support{" "}
              </span>
              <span>for a customized experience</span>
            </p>
          ) : (
            <p>
              Not sure which to choose,{" "}
              <span onClick={startFreeTrial} style={{ color: "rgb(165, 126, 17)", fontWeight: "800", textDecoration: "underline", cursor: "pointer" }}>
                Start a 7 days free trial.
              </span>
              ? {/* you can start a <span style={{ color: "#b6a843", cursor: "pointer", fontWeight: "bold" }}>free 2 days Trial </span> */}{" "}
              <span>For a customized experience </span>
              <span
                onClick={() => {
                  window.open(`${WHATSAPP_BASE}?text=Hello, I would like to inquire aboutyour subscription option.`, "_blank");
                }}
                style={{ color: "rgb(9, 76, 126)", cursor: "pointer", fontWeight: "bold", textDecoration: "underline" }}
              >
                Contact support{" "}
              </span>
            </p>
          )}
          {isLoading && <Spinner position={"fixed"} backgroundColor='rgba(240, 240, 240, 0.46)' />}
        </div>
      ) : user.freeTrial ? (
        <>
          <TrialShowcase setIsLoading={setIsLoading} socket={socket} />
          {isLoading && <Spinner position={"fixed"} backgroundColor='rgba(240, 240, 240, 0.46)' />}
        </>
      ) : (
        <>
          <div className='userIsSubscribedDIv'>
            <h3 className='privacy-data-info-title cp-title' style={{ fontWeight: "800", marginBottom: "30px", padding: "20px 0" }}>
              Update subscription plan
            </h3>

            {user.userType.userType === "starter" && <StarterPlanCard currency={user.userCountryCurrencySymbol} />}

            <UpdateSubscription user={user} socket={socket} setIsLoading={setIsLoading} currency={user.userCountryCurrencySymbol} />
            <div className='subInfo352'>
              <div>
                For a more customized experience, you can{" "}
                <a style={{ color: "rgb(14, 145, 181)", margin: "0 4px" }} href='#'>
                  Contact support
                </a>{" "}
                for an enterprise package
              </div>
            </div>
            <button onClick={handleCancelSubscription} className='cancelSubButton'>
              Cancel subscription
            </button>
            {user.userType.userType === "Online vendors plan" && (
              <span className='onlineVTag'>
                <span></span>
                {user.userType.userType}
              </span>
            )}
          </div>
          {isLoading && <Spinner position={"fixed"} backgroundColor='rgba(240, 240, 240, 0.46)' />}
        </>
      )}
      {openOnlineVendorModal && <OnlineVendor setOpenOnlineVendorModal={setOpenOnlineVendorModal} />}
    </>
  );
};

export default ManageSubscription;

/* online vendor is a free plan */

const OnlineVendor = ({ setOpenOnlineVendorModal }) => {
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const freePlanFeatures = [
    "Create one store",
    "E Commerce store setup",
    "List upto 50 products",
    "Basic support",
    "Access to Community Hub",
    "1% discount on extra services",
  ];
  const startStarterPlan = async () => {
    let accessToken = localStorage.getItem("accessToken");
    setIsLoading(true);
    try {
      let response = await fetch(startStarterPlanUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.status === 400) {
        /* send refresh token */
        console.log("expired token send refresh token");
        navigate("/sign-in");
      }
      if (response.ok) {
        let user = await response.json();
        console.log("starter plan activated", user);
        dispatch(setUser(user));
        uiAlert("You have successfully started the Free Plan", "success");
        setOpenOnlineVendorModal(false);
      }
    } catch (error) {
      console.log(error);
      uiAlert("An error occurred. Please try again.", "error");
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      {/* <div onClick={() => setOpenOnlineVendorModal(false)} className='onlineVendorWrapper'>
        <div onClick={(e) => e.stopPropagation()} className='vendorCont3763'>
          <div className='headerMonk23'>
            <p>Online Vendor package</p>
          </div>
          <div className='vCardue664'>
            <div>
              <h4>No physical store</h4>
              <div className='njshd7d7'>
                <p className='njsufbshd7d7'>
                  This plan is for online vendors only. <br /> It includes all the features of the supper user plan
                </p>
              </div>
            </div>
            <div>
              <h4>List up 50 products</h4>
              <div className='njshd7d7'>
                <p className='njsufbshd7d7'> Manage up to fifty products in your online store. Perfect for growing businesses with large catalogs..</p>
              </div>
            </div>
            <div>
              <h4>Real time analytics</h4>
              <div className='njshd7d7'>
                <p className='njsufbshd7d7'>
                  Monitor store performance with live insights. <br /> See customer activity and product trends instantly.
                </p>
              </div>
            </div>
          </div>

          <div className='bottomDiv8hjbd'>
            <button>Buy now ₦10,000 for 6 months</button>
            <button onClick={() => setOpenOnlineVendorModal(false)}>
              {" "}
              <BsArrowBarLeft /> Choose another
            </button>
          </div>
        </div>
      </div> */}
      <div className='prcard__overlay__backdrop__fullscreen__6k9m2n'>
        <div className='prcard__overlay__modal__content__4p7k5m'>
          {/* Close Button */}
          <button onClick={() => setOpenOnlineVendorModal(false)} className='prcard__close__button__top__right__8n3k7q'>
            <X className='prcard__close__icon__svg__2m6p9k' />
          </button>

          {/* Content */}
          <div className='prcard__overlay__inner__wrapper__5k8n4p'>
            <div className='prcard__success__icon__circle__9m2k7n'>
              <Check className='prcard__success__check__svg__3p6k8q' />
            </div>

            <h3 className='prcard__overlay__heading__title__7k4m9p'>Free Plan Selected</h3>

            <div className='prcard__overlay__details__section__2n8k5m'>
              <p className='prcard__overlay__description__text__6p3k9n'>Start your free trial with no credit card required!</p>

              <div className='prcard__free__features__box__4m8k2p'>
                <h4 className='prcard__free__features__title__7n3k6q'>What's included in the Free Plan:</h4>
                <ul className='prcard__free__features__list__9k2m5p'>
                  {freePlanFeatures.map((feature, idx) => (
                    <li key={idx} className='prcard__free__feature__item__6p8k3m'>
                      <Check className='prcard__free__check__icon__4k7n2q' />
                      <span>{feature}</span>
                    </li>
                  ))}
                </ul>
              </div>
            </div>

            <div className='prcard__overlay__buttons__group__5k2n8m'>
              <button
                onClick={() => {
                  return startStarterPlan();
                }}
                className='prcard__overlay__primary__btn__checkout__7m9k4p'
              >
                Start Free Trial
              </button>
              <button onClick={() => setOpenOnlineVendorModal(false)} className='prcard__overlay__secondary__btn__back__3n6k8q'>
                Go Back
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const UpdateSubscription = ({ user, socket, setIsLoading, currency }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const popup = new PaystackPop();

  useEffect(() => {
    // listen to socket event for payment created
    socket.on("userSuscribed", (user) => {
      if (user._id === user._id) {
        uiAlert("user subscribed", "success");
        dispatch(setUser(user));
        setIsLoading(false);
      }
      console.log("user subscribed", user);
    });
  }, []);

  const handleSubSelection = async (selected) => {
    let accessToken = localStorage.getItem("accessToken");
    console.log(selected);

    try {
      let response = await fetch(subscriptionURL, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(selected),
      });
      if (response.status === 400) {
        /* send refresh token */
        console.log("expired token send refresh token");
        navigate("/sign-in");
      }
      if (response.ok) {
        socket.emit("paymentCreated", user._id);
        let { accessCode } = await response.json();
        popup.resumeTransaction(accessCode, {
          onCancel: function () {
            setIsLoading(false);
          },
        });
        setIsLoading(true);
      }
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <>
      <div className='updSub36453'>
        <div
          style={
            user.userType?.userType?.includes("Basic")
              ? {
                  scale: "1.05",
                  transition: "all 1s ease-in-out",
                  boxShadow: "0px 0px 30px 0 rgb(225, 236, 255) ",
                  border: "1px solid rgb(76, 136, 247) ",
                }
              : {}
          }
        >
          <div className='subCardHeader8d'>
            <span>Basic plan</span>
            <p>
              {" "}
              <span></span> Saver
            </p>
          </div>
          <p className='subCardPriceWrp399'>
            <b className='subCardPrice0999'> {currency}19,000 </b>/six months
          </p>
          {user.userType?.userType?.includes("Basic") ? (
            <div>
              <BsCalendarDate color='rgb(14, 73, 181)' />
              <p style={{ color: user.userType?.renewDate ? "" : "#bc0707", fontWeight: "700" }}>
                {" "}
                {user.userType?.renewDate ? "Renews" : "Ends"} {new Date(user.userType?.subcriptionEndDate).toDateString()}
              </p>
            </div>
          ) : (
            ""
          )}
          {user.userType?.userType?.includes("Basic") ? (
            <div style={{ backgroundColor: "rgb(255, 225, 103)" }} className='cardbtnDivd'>
              Current plan
            </div>
          ) : (
            <div
              onClick={() =>
                handleSubSelection({
                  userType: "Basic",
                  price: "50000",
                  subscriptionRange: "halfYear",
                  plan_code: subscriptionPlanCodes.halfYearly[0].planCode,
                })
              }
              className='cardbtnDivd'
            >
              Choose
            </div>
          )}
          <div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Create one store</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Business KPI tracking</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span> List only 250 products</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Free support</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Access to E-commerce Hub</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Free personel training</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>2% discount on extra services</span>
            </div>
          </div>
        </div>
        <div
          style={
            user.userType?.userType?.includes("Super")
              ? {
                  scale: "1.05",
                  transition: "all 1s ease-in-out",
                  boxShadow: "0px 0px 30px 0 rgb(161, 159, 159) ",
                  color: "white",
                  backgroundColor: "rgb(6, 6, 6)",
                  border: "2px solid rgb(252, 232, 44) ",
                }
              : { color: "white", backgroundColor: "rgb(6, 6, 6)" }
          }
        >
          <div className='subCardHeader8d'>
            <span style={{ color: "white" }}>Super plan</span>
            <p style={{ backgroundColor: "#FCE82C", color: "rgb(107, 103, 21)", boxShadow: "none" }}>
              {" "}
              <span style={{ backgroundColor: "rgb(79, 75, 7)" }}></span> Popular
            </p>
          </div>
          <p className='subCardPriceWrp399'>
            <b className='subCardPrice0999'>{currency}55,000</b> /six months
          </p>
          {user.userType?.userType?.includes("Super") ? (
            <div>
              <BsCalendarDate color='rgb(255, 255, 255)' />
              <p>
                {" "}
                {user.userType.renewDate ? "Renews" : "Ends"} {new Date(user.userType?.subcriptionEndDate).toDateString()}
              </p>
            </div>
          ) : (
            ""
          )}
          {user.userType?.userType?.includes("Super") ? (
            <div style={{ backgroundColor: "rgb(238, 238, 29)", color: "black" }} className='cardbtnDivd'>
              Current plan
            </div>
          ) : (
            <div
              onClick={() =>
                handleSubSelection({
                  userType: "Super",
                  price: "50000",
                  subscriptionRange: "halfYear",
                  plan_code: subscriptionPlanCodes.halfYearly[1].planCode,
                })
              }
              style={{ backgroundColor: "white", color: "black", fontWeight: "700" }}
              className='cardbtnDivd'
            >
              Upgrade
            </div>
          )}
          <div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>Basic user Ad ons</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>Create two stores</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>Create one warehouse</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>24 hours free Ad monthly</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>List upto 1500 products</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>Free hardware installation and leasing options</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>10% discount on extra services</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span style={{ borderColor: "white" }}>
                <BsCheck color='white' />
              </span>
              <span>Free personel training</span>
            </div>
          </div>
        </div>

        <div
          style={
            user.userType?.userType?.includes("Premium")
              ? {
                  scale: "1.05",
                  transition: "all 1s ease-in-out",
                  boxShadow: "0px 0px 30px 0 rgb(225, 236, 255) ",
                  border: "1px solid rgb(76, 136, 247) ",
                }
              : {}
          }
        >
          <div className='subCardHeader8d'>
            <span>Premium plan</span>
            <p>
              {" "}
              <span></span> Saver
            </p>
          </div>
          <p className='subCardPriceWrp399'>
            <b className='subCardPrice0999'>{currency}125,000 </b>/six months
          </p>
          {user.userType.userType?.includes("Premium") ? (
            <div>
              <BsCalendarDate color='rgb(14, 73, 181)' />
              <p>
                {user.userType?.renewDate ? "Renews" : "Ends"} {new Date(user.userType?.subcriptionEndDate).toDateString()}
              </p>
            </div>
          ) : (
            ""
          )}
          {user.userType?.userType?.includes("Premium") ? (
            <div style={{ backgroundColor: "rgb(255, 225, 103)" }} className='cardbtnDivd'>
              Current plan
            </div>
          ) : (
            <div
              onClick={() =>
                handleSubSelection({
                  userType: "Premium",
                  price: "50000",
                  subscriptionRange: "halfYear",
                  plan_code: subscriptionPlanCodes.halfYearly[2].planCode,
                })
              }
              style={{ fontWeight: "700", backgroundColor: "#0e49b5", color: "white" }}
              className='cardbtnDivd'
            >
              Upgrade
            </div>
          )}
          <div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Super user Ad ons</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Create upto Five stores</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Create 3 warehouses</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>150hrs free Ad monthly</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>List upto 11500 products</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Free hardware installation</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>30% discount on extra services</span>
            </div>
            <div className='subCardIncludesDiv'>
              <span>
                <BsCheck color='green' />
              </span>
              <span>Free personel training</span>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const StarterPlanCard = ({ currency }) => {
  return (
    <>
      <div className='current-plan-banner'>
        <div className='current-plan-content'>
          <div className='current-plan-info'>
            <div className='current-plan-header'>
              <span className='current-plan-badge'>ACTIVE</span>
              <h3 className='current-plan-title'>Starter Plan</h3>
            </div>
            <p className='current-plan-description'>You're currently on the free Starter plan with basic features</p>
            <div className='current-plan-features'>
              <div className='current-plan-feature-item'>
                <Check className='current-plan-feature-icon' />
                <span>Limited features</span>
              </div>
              <div className='current-plan-feature-item'>
                <Check className='current-plan-feature-icon' />
                <span>Community support</span>
              </div>
              <div className='current-plan-feature-item'>
                <Check className='current-plan-feature-icon' />
                <span>Basic access</span>
              </div>
            </div>
          </div>
          <div className='current-plan-pricing'>
            <div className='current-plan-price'> {currency}0</div>
            <div className='current-plan-period'>Forever free</div>
          </div>
        </div>
      </div>
    </>
  );
};
